<template>
  <div>
    <div>
      <form>
        <div class="box-body">
          <div class="row">
            <div class="col-md-4">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="" for="">{{
                      $t("userExtraInfo.joinedDate")
                    }}</label>
                    <date-picker
                      :placeholder="$t('userExtraInfo.joinedDate')"
                      :config="dateOptions"
                      v-model="userExtraInfoData.joinedDate"
                    ></date-picker>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="" for="">{{
                      $t("userExtraInfo.contractSigningDate")
                    }}</label>
                    <date-picker
                      :placeholder="$t('userExtraInfo.contractSigningDate')"
                      :config="dateOptions"
                      v-model="userExtraInfoData.contractSigningDate"
                    ></date-picker>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="" for="">{{
                      $t("userExtraInfo.position")
                    }}</label>
                    <v-select
                      class="clear"
                      :options="positionList"
                      :reduce="data => data.value"
                      :getOptionLabel="option => $t(option.positionName)"
                      v-model="userExtraInfoData.position"
                      :placeholder="$t('userExtraInfo.department')"
                    >
                      <template v-slot:option="option">
                        {{ option.positionName }}
                      </template>
                    </v-select>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="" for="">{{
                      $t("userExtraInfo.department")
                    }}</label>
                    <v-select
                      class="clear"
                      :options="departmentItems"
                      :reduce="data => data.value"
                      :getOptionLabel="option => $t(option.departmentName)"
                      v-model="userExtraInfoData.department"
                      :placeholder="$t('userExtraInfo.department')"
                    >
                      <template v-slot:option="option">
                        {{ option.departmentName }}
                      </template>
                    </v-select>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="" for="">{{
                      $t("userExtraInfo.identificationnumber")
                    }}</label>

                    <input
                      :placeholder="$t('userExtraInfo.identificationnumber')"
                      class="form-control"
                      type="text"
                      name=""
                      id=""
                      v-model="userExtraInfoData.identificationnumber"
                    />
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="" for="">{{
                      $t("userExtraInfo.dateCreateIdentificationnumber")
                    }}</label>
                    <date-picker
                      :placeholder="
                        $t('userExtraInfo.dateCreateIdentificationnumber')
                      "
                      :config="dateOptions"
                      v-model="userExtraInfoData.dateCreateIdentificationnumber"
                    ></date-picker>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="" for="">{{
                      $t("userExtraInfo.placeCreateIdentificationnumber")
                    }}</label>
                    <input
                      :placeholder="
                        $t('userExtraInfo.placeCreateIdentificationnumber')
                      "
                      class="form-control"
                      type="text"
                      name=""
                      id=""
                      v-model="
                        userExtraInfoData.placeCreateIdentificationnumber
                      "
                    />
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      id="exampleCheck2"
                      v-model="userExtraInfoData.participateInInsurance"
                    />
                    <label class="form-check-label" for="exampleCheck2">{{
                      $t("userExtraInfo.participateInInsurance")
                    }}</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="row">
                <div class="col-md-12" style="margin-bottom: 10px;">
                  <div
                    class="class-border"
                    style="display: flex; justify-content: space-between; padding: 5px 10px;"
                  >
                    <span style="align-self: center;">{{
                      $t("userExtraInfo.staffImg")
                    }}</span>
                    <div style="width: fit-content;">
                      <span
                        class="btn btn-primary"
                        style="padding: 2px 5px;"
                        @click="onClickStaffImg"
                        ><i class="fa fa-paperclip " aria-hidden="true"></i
                      ></span>
                      <span
                        class="btn btn-danger"
                        style="padding: 2px 5px;"
                        @click="onClickDeleteStaffImg"
                        ><i class="glyphicon glyphicon-trash"></i
                      ></span>
                    </div>
                  </div>
                  <div class="content-border-class" style="padding: 5px">
                    <img
                      :src="
                        isEmptyString(userExtraInfoData.staffImg)
                          ? noImgDefault
                          : userExtraInfoData.staffImg
                      "
                      alt=""
                      class="staff-img img-responsive"
                    />
                  </div>
                </div>
                <div class="col-md-12">
                  <div
                    class="class-border"
                    style="display: flex; justify-content: space-between; padding: 5px 10px;"
                  >
                    <span style="align-self: center;">{{
                      $t("userExtraInfo.attachFileList")
                    }}</span>
                    <div style="width: fit-content;">
                      <span
                        class="btn btn-primary"
                        style="padding: 2px 5px;"
                        @click="onClickAttachFile"
                        ><i class="fa fa-paperclip " aria-hidden="true"></i
                      ></span>
                      <span
                        class="btn btn-danger"
                        style="padding: 2px 5px;"
                        @click="onClickDeleteAttachFile"
                        ><i class="glyphicon glyphicon-trash"></i
                      ></span>
                    </div>
                  </div>
                  <div class="content-border-class attach-file-class">
                    <div
                      v-for="(attachFileItem, index) in attachFileList"
                      :key="attachFileItem + index"
                      style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis; display: flex"
                    >
                      <input
                        type="checkbox"
                        class="form-check-input"
                        :id="index"
                        v-model="attachFileItem.enable"
                      />
                      <label
                        :title="attachFileItem.fileName"
                        class="form-check-label attach-file-name"
                        style="padding-left: 5px;"
                        @click="onClickOpenAttachFile(attachFileItem.pdfUrl)"
                      >
                        {{ attachFileItem.fileName }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="box-footer">
          <button
            type="button"
            class="btn btn-labeled btn-danger"
            @click="onCallBack"
            style="margin-right: 5px; background-color: #f29911;border-color: #f29911;"
          >
            <span class="btn-label"> <i class="fa fa-mail-reply"></i> </span>
            {{ $t("common.back") }}
          </button>
          <button
            type="button"
            class="btn btn-labeled btn-success pull-right"
            @click="onSave"
            style="margin-right: 5px;"
          >
            <span class="btn-label">
              <i class="glyphicon glyphicon-ok"></i>
            </span>
            {{ $t("common.save") }}
          </button>
        </div>
      </form>
    </div>
    <!--  -->
    <input
      :id="`upload-file-input`"
      type="file"
      accept="image/*"
      @change="onSelectFile"
    />
    <!--  -->
    <component-file-pdf-with-file-name
      ref="componentFilePdfWithFileName"
      :titleModal="uploadPdfFileTitle"
      @uploadPdfFileEmit="handleUpdateAttachFileList"
    />
    <!--  -->
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
  </div>
</template>
<script>
import datePicker from "vue-bootstrap-datetimepicker";
import configuration from "@/lib/config";
import utils from "@/lib/utils";
import { mapActions, mapGetters } from "vuex";
import axios from "axios";
import ComponentFilePdfWithFileName from "@/components/ComponentFilePdfWithFileName.vue";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import Loading from "vue-loading-overlay";

export default {
  components: {
    "date-picker": datePicker,
    "lte-core-alert": LTECoreAlert,
    ComponentFilePdfWithFileName,
    loading: Loading
  },
  data: () => ({
    isLoading: false,
    dateOptions: {
      format: "DD/MM/YYYY",
      useCurrent: false
    },
    //
    noImgDefault: configuration.imgUrlConfig.no_img_avatar,
    media_server: {
      domain: "",
      token: ""
    },
    imgFileSize: null,
    //
    userExtraInfoData: {
      id: 0,
      joinedDate: null,
      contractSigningDate: null,
      position: null,
      department: null,
      identificationnumber: null,
      dateCreateIdentificationnumber: null,
      placeCreateIdentificationnumber: null,
      staffImg: null,
      participateInInsurance: false
    },
    uploadPdfFileTitle: "",
    attachFileList: [],
    departmentItems: [],
    positionList: [],
    userId: null
  }),
  watch: {
    GET_TOKEN_UPLOAD_DATA: function() {
      let data = this.GET_TOKEN_UPLOAD_DATA;
      this.media_server.domain = data.domain;
      this.media_server.token = data.token;
    },
    GET_DEPARTMENT_LIST_DATA: function() {
      let data = this.GET_DEPARTMENT_LIST_DATA;
      this.departmentItems = [];
      data.forEach((value, i) => {
        let item = {
          value: value.id,
          departmentName: value.name
        };
        this.departmentItems.push(item);
      });
    },
    GET_POSITION_LIST_DATA: function() {
      let data = this.GET_POSITION_LIST_DATA;
      this.positionList = [];
      data.forEach((value, i) => {
        let item = {
          value: value.id,
          positionName: value.name
        };
        this.positionList.push(item);
      });
    },
    GET_USER_EXTRA_INFO_DATA: function() {
      let data = this.GET_USER_EXTRA_INFO_DATA;
      if (Object.keys(data).length > 0) {
        this.userExtraInfoData.id = data && data.id;
        this.userExtraInfoData.joinedDate = utils.formatSqlDate(data.joined_date, null, "DD/MM/YYYY");
        this.userExtraInfoData.contractSigningDate = utils.formatSqlDate(data.contract_signing_date, null, "DD/MM/YYYY");
        this.userExtraInfoData.position = data.position;
        this.userExtraInfoData.department = data.department;
        this.userExtraInfoData.participateInInsurance =
          data.participate_in_insurance;
        this.userExtraInfoData.staffImg = data.staff_img;
        this.userExtraInfoData.identificationnumber = data.identificationnumber;
        this.userExtraInfoData.dateCreateIdentificationnumber = utils.formatSqlDate(data.date_create_identificationnumber, null, "DD/MM/YYYY");
        this.userExtraInfoData.placeCreateIdentificationnumber =
          data.place_create_identificationnumber;
        // get file attach
        let files = data.files;
        this.attachFileList = [];
        files.forEach((f, index) => {
          let item = {
            id: f.id,
            pdfUrl: f.url_file,
            fileName: f.file_name,
            index: index,
            enable: false
          };
          this.attachFileList.push(item);
        });
      } else {
        this.userExtraInfoData = {
          id: 0,
          joinedDate: null,
          contractSigningDate: null,
          position: null,
          department: null,
          identificationnumber: null,
          dateCreateIdentificationnumber: null,
          placeCreateIdentificationnumber: null,
          staffImg: null,
          participateInInsurance: false
        };
        this.attachFileList = [];
      }
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "GET_TOKEN_UPLOAD_DATA",
      "GET_DEPARTMENT_LIST_DATA",
      "GET_POSITION_LIST_DATA",
      "GET_USER_EXTRA_INFO_DATA"
    ])
  },
  methods: {
    onCallBack: function() {
      window.history.back();
    },
    showError: function(msg) {
      this.ON_SHOW_TOAST({
        message: this.$t(msg),
        styleType: "danger"
      });
    },
    isEmptyString: function(value) {
      return utils.isEmptyString(value);
    },
    // upload file
    onSelectFile: async function(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.getResultFile(files[0]);
      this.imgFileSize = files[0].size;
      // // upload staff img
      this.userExtraInfoData.staffImg = URL.createObjectURL(files[0]);
      await this.uploadImgFunction();
    },
    /**
     * Get result file
     */
    getResultFile: function(file) {
      let vm = this;
      vm.imgFileData = file;
    },
    uploadImgFunction: async function() {
      if (this.imgFileSize > 10000000) {
        this.ON_SHOW_TOAST({
          message: this.$t("common.cannotExceed10MB"),
          styleType: "danger"
        });
      } else {
        let formData = new FormData();
        formData.append("file", this.imgFileData);
        formData.append("directory", "staffInfo");
        formData.append("forceOverride", true);
        await axios({
          method: "POST",
          timeout: 6000,
          url: this.media_server.domain + "/api/v1/upload/",
          data: formData,
          headers: { Authorization: `JWT ${this.media_server.token}` }
        })
          .then(
            function(res) {
              let imgUrl = res.data.domain + res.data.url;
              // is upload staff img
              this.userExtraInfoData.staffImg = imgUrl;
            }.bind(this)
          )
          .catch(
            function(error) {
              this.ON_SHOW_TOAST({
                message: error.response.data.message,
                styleType: "danger"
              });
            }.bind(this)
          );
      }
    },
    onOpenInputSelectFile: function() {
      $(`#upload-file-input`).val("");
      $(`#upload-file-input`).click();
    },
    // select staff img
    onClickStaffImg: function() {
      this.onOpenInputSelectFile();
    },
    onClickDeleteStaffImg: function() {
      this.userExtraInfoData.staffImg = null;
    },
    // end upload staff img
    // upload file attach
    onClickAttachFile: function() {
      let attachFileSelect = this.attachFileList.filter(x => x.enable === true);
      if (attachFileSelect.length === 0) {
        this.uploadPdfFileTitle = "common.addPdfFile";
        this.$refs.componentFilePdfWithFileName.onShowAddNew(
          this.attachFileList.length + 1
        );
      } else if (attachFileSelect.length === 1) {
        this.uploadPdfFileTitle = "common.updatePdfFile";
        this.$refs.componentFilePdfWithFileName.onShowDetail(
          attachFileSelect[0]
        );
      } else {
        this.showError();
      }
    },
    onClickDeleteAttachFile: function() {
      this.attachFileList = this.attachFileList.filter(x => x.enable === false);
    },
    handleUpdateAttachFileList: function(data) {
      let item = {
        id: data.id,
        pdfUrl: data.pdfUrl,
        fileName: data.fileName,
        index: data.index,
        enable: false
      };
      let searchIndex = this.attachFileList.findIndex(
        x => x.index === data.index
      );
      if (searchIndex === -1) {
        this.attachFileList.push(item);
      } else {
        this.attachFileList[searchIndex].id = item.id;
        this.attachFileList[searchIndex].pdfUrl = item.pdfUrl;
        this.attachFileList[searchIndex].fileName = item.fileName;
        this.attachFileList[searchIndex].enable = item.enable;
      }
    },
    validateData: function() {
      let validatedResult = "OK";
      for (let key in this.userExtraInfoData) {
        if (key === "userExtraInfoData.staffImg") {
          // 
        }
        else if (utils.isEmptyString(this.userExtraInfoData[key])) {
          validatedResult = this.$t("userExtraInfo." + key);
          break;
        }
      }
      return validatedResult;
    },
    onSave: function() {
      let result = this.validateData();
      if (result === "OK") {
        //
        let data = {
          id: this.userExtraInfoData.id,
          joinedDate: utils.formatSqlUtcDate(this.userExtraInfoData.joinedDate, "DD/MM/YYYY", "YYYY-MM-DD HH:mm:ss"),
          contractSigningDate: utils.formatSqlUtcDate(this.userExtraInfoData.contractSigningDate, "DD/MM/YYYY", "YYYY-MM-DD HH:mm:ss"),
          positionId: this.userExtraInfoData.position,
          departmentId: this.userExtraInfoData.department,
          identificationnumber: this.userExtraInfoData.identificationnumber,
          dateCreateIdentificationnumber: utils.formatSqlUtcDate(this.userExtraInfoData.dateCreateIdentificationnumber,"DD/MM/YYYY", "YYYY-MM-DD HH:mm:ss"),
          placeCreateIdentificationnumber: this.userExtraInfoData.placeCreateIdentificationnumber,
          participateInInsurance: this.userExtraInfoData.participateInInsurance,
          userId: this.userId,
          staffImg: this.userExtraInfoData.staffImg,
          attachFile: this.attachFileList
        };
        if (this.userExtraInfoData.id === 0) {
          this.ADD_USER_EXTRA_INFO(data)
            .then(
              function() {
                this.isLoading = false;
                this.SUCCESS_TOAST();
                this.getUserExtraInfo(this.userId);
              }.bind(this)
            )
            .catch(
              function() {
                this.isLoading = false;
              }.bind(this)
            );
        } else {
          this.UPDATE_USER_EXTRA_INFO(data)
            .then(
              function() {
                this.isLoading = false;
                this.SUCCESS_TOAST();
                this.getUserExtraInfo(this.userId);
              }.bind(this)
            )
            .catch(
              function() {
                this.isLoading = false;
              }.bind(this)
            );
        }
      } else {
        this.showError(result);
      }
    },
    getDepartmentList: function() {
      this.GET_DEPARTMENT_LIST();
    },
    getPositionList: function() {
      this.GET_POSITION_LIST();
    },
    getRefreshData: function(userId) {
      this.userId = userId;
      this.getUserExtraInfo(userId);
    },
    getUserExtraInfo: function(userId) {
      let filter = {
        params: {
          userId: userId
        }
      };
      this.isLoading = true;
      this.GET_USER_EXTRA_INFO(filter)
        .then(
          function() {
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function() {
            this.isLoading = false;
          }.bind(this)
        );
    },
    onClickOpenAttachFile: function(url) {
      window.open(url)
    },
    ...mapActions([
      "ON_SHOW_TOAST",
      "SUCCESS_TOAST",
      "GET_TOKEN_UPLOAD",
      "GET_DEPARTMENT_LIST",
      "GET_POSITION_LIST",
      "GET_USER_EXTRA_INFO",
      "ADD_USER_EXTRA_INFO",
      "UPDATE_USER_EXTRA_INFO"
    ])
  },
  mounted() {
    this.getDepartmentList();
    this.getPositionList();
    this.GET_TOKEN_UPLOAD();
  }
};
</script>
<style scoped>
.class-border {
  border: 1px solid #cccccc;
}
.content-border-class {
  border-left: 1px solid #cccccc;
  border-right: 1px solid #cccccc;
  border-bottom: 1px solid #cccccc;
}
.staff-img {
  width: 100%;
  max-width: 150px;
  max-height: 150px;
  margin: auto;
  /* height: 150px; */
}
.attach-file-class {
  max-height: 150px;
  overflow: auto;
  padding: 10px;
}
/*  */
input[type="file"] {
  display: none;
}
.attach-file-name:hover {
  text-decoration: underline;
  color: blue;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/User/UserExtraInfo.vue